<template>
  <footer class="cobalt-bg-color">
    <div
      class="mt-1 ml-10 flex flex-col sm:flex-row sm:flex-wrap sm:mt-0 sm:space-x-10"
    >
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="att_user.length == 0"
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          ></path>
        </svg>
        <router-link
          to="/login"
          class="footer-text-color my-3 block hover:text-white text-sm font-medium duration-700"
        >
          Register/Login
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="leadData.length == 0 && att_user.length == 0"
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          ></path>
        </svg>
        <router-link
          to="/sign-in"
          class="footer-text-color my-3 block hover:text-white text-sm font-medium duration-700"
        >
          Sign In
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="
          att_user?.data?.password != null && att_user?.data?.password != ''
        "
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
          to="/home"
          class="footer-text-color my-3 block text-sm font-medium duration-700"
        >
          Home
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="
          att_user?.data?.password != null && att_user?.data?.password != ''
        "
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
          to="/update-profile/primary"
          class="footer-text-color my-3 block text-sm font-medium duration-700"
        >
          Profile
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="
          att_user?.data?.password != null && att_user?.data?.password != ''
        "
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
          to="/claims"
          class="footer-text-color my-3 block hover:text-white text-sm font-medium duration-700"
        >
          Claims
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="
          att_user?.data?.password != null && att_user?.data?.password != ''
        "
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
          to="/authorizations"
          class="footer-text-color my-3 block text-sm font-medium duration-700"
        >
          Authorization Requests
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="
          att_user?.data?.password != null && att_user?.data?.password != ''
        "
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
          to="/cases"
          class="footer-text-color my-3 block text-sm font-medium duration-700"
        >
          Cases
        </router-link>
      </div>
      <div
        class="footer-icon mt-2 flex items-center text-sm"
        v-if="
          (leadData.length != 0 &&
            leadData.result.lead[0].attorney_id == null)
        "
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
          to="/application"
          class="footer-text-color my-3 block text-sm font-medium duration-700"
        >
          Application
        </router-link>
      </div>
    </div>
    <div class="">
      <div
        class="footer-desc-color flex pb-5 px-3 m-auto pt-5 
            border-t border-gray-500 text-white text-sm 
            flex-col md:flex-row max-w-6xl"
      >
        <div class="mt-2">
          © U.S.Legal Services 2021. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "Footer",
  computed: mapState(["leadData", "att_user"]),
};
</script>
